import React from 'react';

import styled from 'styled-components';

export default function Member({ name, image, role, info, careers }) {
  return (
    <StyledMember>
      <StyledImageContainer>
        <StyledImage alt="profile image" src={image} />
        <StyledCarrer>
          {careers.map((carrer, idx) => (
            <li key={idx}>{carrer}</li>
          ))}
        </StyledCarrer>
      </StyledImageContainer>
      <StyledName>{name}</StyledName>
      <StyledRole>{role}</StyledRole>
      <StyledInfo>{info}</StyledInfo>
    </StyledMember>
  );
}

const StyledMember = styled.li`
  max-width: 278px;
  margin-bottom: 56px;
  position: relative;

  div {
    line-height: 1.35;
  }

  ${({ theme }) => theme.mobile`
      margin-bottom: 20px;
      max-width: 47.95%;

    `}
`;

const StyledImageContainer = styled.div`
  position: relative;
`;

const StyledImage = styled.img`
  width: 100%;
  ${({ theme }) => theme.mobile`
  width: 100%;
    `}
`;

const StyledCarrer = styled.ul`
  position: absolute;
  padding: 13% 5% 5% 15%;
  width: 100%;
  height: 97%;
  top: 0;
  left: 0;
  opacity: 0;
  background-color: rgba(0, 0, 0, 0.7);

  > li {
    margin-bottom: 2px;
    color: white;
    font-size: 14px;
    line-height: 2;
    list-style-type: disc;

    ${({ theme }) => theme.mobile`
      // font-size: ${({ theme }) => theme.pixelToMobileVw(12)};
      font-size: 12px;
      line-height: 1.6;
    `}
  }

  ${({ theme }) => theme.mobile`
    height: 97%;
  `}
`;

const StyledName = styled.div`
  font-size: ${({ theme }) => theme.pixelToRem(24)};
  font-weight: 700;
`;

const StyledRole = styled.div`
  margin-bottom: 10px;
  padding-bottom: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.grey2};
`;

const StyledInfo = styled.p`
  color: ${({ theme }) => theme.colors.grey1};
  font-size: ${({ theme }) => theme.pixelToRem(16)};
  line-height: 1.5;
  word-break: normal;
`;
